import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
interface SlideProps {
  index: number;
  total: number;
}
export function Slide6Stage1({
  index
}: SlideProps) {
  return <div className="relative w-screen h-screen overflow-hidden bg-[var(--bg)] p-[clamp(2rem,4vw,4rem)] flex flex-col" data-id="element-229">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2,
      duration: 0.6
    }} className="mb-[clamp(1.5rem,2.5vw,2.5rem)] flex-shrink-0" data-id="element-230">
        <p className="text-[var(--brand-green)] text-[clamp(0.875rem,1.5vw,1.125rem)] font-semibold uppercase tracking-wider mb-[clamp(0.5rem,1vw,1rem)]" data-id="element-231">
          Stage 1
        </p>
        <h2 className="text-[var(--fg)] font-bold text-[clamp(2rem,3.6vw,3.25rem)] leading-[1.08] max-w-5xl" data-id="element-232">
          Snakkify DermaWorld Anzupgo pages with{' '}
          <span className="text-[var(--brand-green-light)]" data-id="element-233">
            easy-to-digest modules.
          </span>
        </h2>
      </motion.div>

      <div className="flex-1 grid grid-cols-12 gap-[clamp(1.5rem,3vw,3rem)] min-h-0" data-id="element-234">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.4,
        duration: 0.5
      }} className="col-span-6 flex flex-col justify-center" data-id="element-235">
          <p className="text-[var(--fg)] text-[clamp(1.1rem,1.5vw,1.5rem)] font-medium leading-relaxed mb-6" data-id="element-236">
            First, Snakker creates an easy-to-digest Snak layer for DermaWorld
            Anzupgo pages. The purpose is to make key website content easier,
            faster, and more relevant for HCPs to consume.
          </p>
          <div className="bg-[var(--surface)] p-6 rounded-2xl border border-black/5 mb-6" data-id="element-237">
            <p className="text-[var(--brand-green)] font-bold text-lg mb-2" data-id="element-238">
              Not one big Snak.
            </p>
            <p className="text-[var(--fg)] font-medium" data-id="element-239">
              It should be a modular set of short, focused Snak experiences
              embedded into or linked from the site.
            </p>
          </div>
          <div className="bg-[var(--brand-green)] text-white p-6 rounded-2xl shadow-md" data-id="element-240">
            <p className="font-bold text-xl text-center" data-id="element-241">
              One audience. One problem. One solution. One CTA.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.6,
        duration: 0.5
      }} className="col-span-6 relative rounded-2xl overflow-hidden shadow-lg border border-black/10" data-id="element-242">
          <img src="https://cdn.magicpatterns.com/uploads/oWdL8FLiMP31C1kB1aH1mU/Screenshot_2026-06-29_at_09.45.03.png" alt="Hands with eczema" className="w-full h-full object-cover" data-id="element-243" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent flex flex-col justify-end p-8" data-id="element-244">
            <h3 className="text-white font-bold text-2xl mb-4" data-id="element-245">
              These Snaks help HCPs:
            </h3>
            <ul className="space-y-2" data-id="element-246">
              {['Stay longer on the website', 'Understand content faster', 'Navigate based on relevance', 'Engage with one problem at a time', 'Choose the content most relevant to their needs', 'Interact instead of only reading'].map((item, i) => <li key={i} className="flex items-center gap-2 text-white/90 font-medium" data-id="element-247">
                  <CheckCircle2 className="w-5 h-5 text-[var(--brand-green-lighter)]" data-id="element-248" />
                  {item}
                </li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </div>;
}